import styled from "styled-components";

const Title = styled.h2`
    padding: 0.25em 0.5em;
    margin: 1.2em 0 0.8em 0;
    display: flex;
    justify-content: center;
    border-radius: 1em;
    align-items: center;
    background: #0001;
    opacity: 0.8;
    text-align: center;
    color: #330205;
`;

export default Title;
